export const DEFAULT_PAGE_SIZE = 100;

export const PAGE_SIZES = [
  5, 10, 25, 50, 100, 250, 500, 1000, 2500, 5000, 10000, 20000,
];

export const PAGE_SIZE_OPTIONS = PAGE_SIZES.map((size) => ({
  value: size,
  label: size,
}));
